import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { CoverExtra, ExtendedBaseCoverExtra } from '../../../ExtrasHelper';
import { Actions } from '../../rules/Actions';
import { getItemValueForAction } from './getItemValueForAction';
import { SmartSendProvider } from '~/lib/consts/providers';

export function allowInlineRule(item: SmartSendItemApiModel, actions: string[]) {
  // The main Rules will pass 3 variations. [Cover], [Cover, ExtendedBaseCover], [ExtendedBaseCover]
  // This logic is to prevent the singluar rules from showing when the group protection rule applies.
  // Usually it would be covered by getItemValueForAction, but the function cant view all the actions at once.
  if (
    (actions.every((x) => x == Actions.Extra_Cover) && item.Extras.find((e) => e.Id === ExtendedBaseCoverExtra)) ||
    (actions.every((x) => x == Actions.Extra_ExtendedBaseCover) && item.Extras.find((e) => e.Id === CoverExtra))
  ) {
    return false;
  }

  // Item_Service only works with provider SmartSendProvider, Item_CourierService works with non-SmartSendProviders.
  if (
    (actions.every((x) => x === Actions.Item_Service) && item.Service.Provider !== SmartSendProvider) ||
    (actions.every((x) => x === Actions.Item_CourierService) && item.Service.Provider === SmartSendProvider)
  ) {
    return false;
  }

  return actions.every((action) => !!getItemValueForAction(item, action));
}
